export enum HTMLButtonTypes {
	SUBMIT = 'submit',
	BUTTON = 'button',
	RESET = 'reset',
}
